const env = import.meta.env;

export type AuthMode = "dev" | "google";

export const config = {
  apiBase: (env.VITE_API_BASE ?? "").replace(/\/+$/, ""),
  authMode: (env.VITE_AUTH_MODE === "google" ? "google" : "dev") as AuthMode,
  googleClientId: env.VITE_GOOGLE_CLIENT_ID ?? "",
  adUnitPath: env.VITE_AD_UNIT_PATH ?? "",
  // never in a production build: a simulated ad must not grant coins on the real site
  fakeAds: Boolean(env.DEV) && env.VITE_FAKE_ADS === "1",
  turnstileSiteKey: env.VITE_TURNSTILE_SITEKEY ?? "",
  maxUploadSide: 4000, // spike 2026-10-18: below ~3000 px shop photos get enlarged when printed
  jpegQuality: 0.92,
  pollMs: 1500,
};
